import { useState } from 'react';

export default function Pricing() {
  const [selectedPlan, setSelectedPlan] = useState<string | null>(null);

  const plans = [
    {
      name: 'Express',
      price: '12',
      duration: 'par course',
      description: 'Idéal pour les livraisons ponctuelles',
      features: [
        'Livraison en 2h',
        'Jusqu\'à 5kg',
        'Suivi en temps réel',
        'Assurance incluse',
        'Support client'
      ],
      popular: false,
      color: 'gray'
    },
    {
      name: 'Urgent',
      price: '19',
      duration: 'par course',
      description: 'Pour vos besoins urgents',
      features: [
        'Livraison en 1h',
        'Jusqu\'à 10kg',
        'Suivi en temps réel',
        'Assurance premium',
        'Support prioritaire',
        'Coursier dédié'
      ],
      popular: true,
      color: 'red'
    }
  ];

  return (
    <section id="tarifs" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tarifs Transparents
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Choisissez la formule qui correspond à vos besoins. Sans engagement, sans frais cachés.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto mb-16">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`relative rounded-2xl p-8 transition-all transform hover:-translate-y-2 cursor-pointer ${
                plan.popular 
                  ? 'bg-red-600 text-white shadow-2xl scale-105' 
                  : 'bg-white border-2 border-gray-200 hover:border-red-600 shadow-lg'
              }`}
              onClick={() => setSelectedPlan(plan.name)}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-yellow-500 text-black px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap">
                    PLUS POPULAIRE
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className={`text-2xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-gray-900'}`}>
                  {plan.name}
                </h3>
                <p className={`text-sm ${plan.popular ? 'text-white/80' : 'text-gray-600'}`}>
                  {plan.description}
                </p>
              </div>

              <div className="text-center mb-8">
                <div className="flex items-baseline justify-center">
                  <span className={`text-5xl font-bold ${plan.popular ? 'text-white' : 'text-gray-900'}`}>
                    {plan.price}€
                  </span>
                </div>
                <p className={`text-sm mt-2 ${plan.popular ? 'text-white/80' : 'text-gray-600'}`}>
                  {plan.duration}
                </p>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className={`ri-check-line text-xl mr-3 flex-shrink-0 ${
                      plan.popular ? 'text-yellow-400' : 'text-green-600'
                    }`}></i>
                    <span className={`text-sm ${plan.popular ? 'text-white' : 'text-gray-700'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <button 
                onClick={() => {
                  const element = document.getElementById('contact');
                  if (element) element.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`w-full py-3 rounded-lg font-bold transition-all whitespace-nowrap ${
                  plan.popular
                    ? 'bg-yellow-500 text-black hover:bg-yellow-400'
                    : 'bg-red-600 text-white hover:bg-red-700'
                }`}
              >
                CHOISIR CE PLAN
              </button>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="bg-gray-50 rounded-2xl p-8 md:p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <i className="ri-shield-check-line text-4xl text-red-600 mb-3"></i>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Assurance Incluse</h4>
              <p className="text-sm text-gray-600">Tous vos colis sont assurés jusqu'à 1000€</p>
            </div>
            <div>
              <i className="ri-customer-service-line text-4xl text-red-600 mb-3"></i>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Support 24/7</h4>
              <p className="text-sm text-gray-600">Notre équipe est disponible à tout moment</p>
            </div>
            <div>
              <i className="ri-refund-line text-4xl text-red-600 mb-3"></i>
              <h4 className="text-lg font-bold text-gray-900 mb-2">Satisfait ou Remboursé</h4>
              <p className="text-sm text-gray-600">Garantie de satisfaction à 100%</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
